import { StoreState } from "@/redux/RootReducer";

export const routeTargetsOverviewSelectors = {
  getSelectedNegotiationYear: (state: StoreState): number | null =>
    state.routeTargetsOverview.selectedYear,
};
